const priceFormatter = (price, currency) => {
    return new Intl.NumberFormat('en-US',
      { style: 'currency', currency: currency }
    ).format(price);
  }
  
  export default priceFormatter;